<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1gfrpl/OEBPS/images/9780740798849_cvi.jpg?1707485958049" alt="This image is the cover for the book Tee Time in Berzerkistan, Doonesbury"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tee Time in Berzerkistan, Doonesbury
      </h1>
      <p class="bookDescription body article font2">
        <p>No rogue regime ever needed its evildoing professionally reframed more urgently than Greater Berzerkistan, whose president-for-life Trff Bmzklfrpz (pronounced "Ptklm") needs to spin a recent round of ethnic cleansing. Fortunately, the pariah state (and its 50-hole golf course, built overnight by Kurds and Jews) borders Iran, a fact that K Street uberlobbyist Duke is retained to parlay into a major U.S. arms package.</p><p>Meanwhile, across town, the crumbling of the newspaper industry crushes Rick Redfern's hope of continuing employment. After 35 years at the <i>Washington Post</i>, he is ejected into the blogosphere, where his prose now battles it out with that of 1,186,783,465 rivals, including Roland Hedley, who takes the art of Twittering to a new self-reverential low.</p><p>Truly, everyone in Doonesburyland is struggling to adapt. While white Washington insiders scramble to acquire some African American friends, longtime black conservative Clyde schemes to score Obama's Blackberry number, Clinton-era Dems are forced to attend the president-elect's "No Drama School," and Jimmy Thudpucker once again reboots his career--this time as a cell phone ring-tone artist.</p><p>No one ever said change was pretty.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        G. B. Trudeau
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?85123af4